import { FunctionalComponent, h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { CheckIcon } from "../../../icons/Check";
import { DollarIcon } from "../../../icons/Dollar";
import { FlameIcon } from "../../../icons/Flame";
import { CheckButton, FlameContainer, FlameIconStyled, ImageStyled, InfoStyled, CircleButton, RewardOfferItemContent } from "./reward-offer-item.style";
import { ItemType, RewardOfferItemI, ItemStatus } from "./reward-offer.types";

export const RewardOfferItem: FunctionalComponent<{ callbackSubmit: (data: any) => void, callbackTapForDetails: (data: any) => void, rewardOfferItem: RewardOfferItemI, itemId: number }> = ({
  callbackSubmit,
  callbackTapForDetails,
  rewardOfferItem,
  itemId
}) => {
  const [item, setItem] = useState(rewardOfferItem);
  const bgColorFlameContainerRewards: string = '#95B040';
  const bgColorFlameContainerOffers: string = '#F6BD45';

  const callToActionOnClick = (id: number, e: any) => {
    callbackSubmit({ id, e });
  };

  const tapForDetails = (id: number, e: any) => {
    callbackTapForDetails({ id, e });
  };

  useEffect(() => {
    if (itemId > -1 && itemId === item.id) {
      updateItemStatus(ItemStatus.Used)
    } else {
      updateItemStatus(ItemStatus.Active)
    }
  }, [itemId]);

  const updateItemStatus = (status: ItemStatus) => {
    setItem((prevState) => {
      return {
        ...prevState,
        status
      }
    });
  }

  return (
    <RewardOfferItemContent >
      <InfoStyled>
        <span class="bottom-title" dangerouslySetInnerHTML={{
          __html: item.bottomTitle
        }}></span>
        {item.expirationDate && (
          <span class="bottom-title-detail">EXPIRES {item.expirationDate} </span>
        )}
        <span class="call-to-action" onClick={tapForDetails.bind(this, item.id)} >{item.callToActionText} </span>
      </InfoStyled>
      <ImageStyled>
        <img src={item.leftImageUrl} />
      </ImageStyled>

      {item.type === ItemType.Reward && (
        <div>
          <FlameContainer enableOpacity={false} color={bgColorFlameContainerRewards}>
            <FlameIconStyled>
              <FlameIcon></FlameIcon>
            </FlameIconStyled>
          </FlameContainer>
          <FlameContainer enableOpacity={true} color={bgColorFlameContainerRewards}></FlameContainer>
        </div>
      )}

      {item.type === ItemType.Offer && (
        <div>
          <FlameContainer enableOpacity={false} color={bgColorFlameContainerOffers}>
            <FlameIconStyled>
              <DollarIcon></DollarIcon>
            </FlameIconStyled>
          </FlameContainer>
          <FlameContainer enableOpacity={true} color={bgColorFlameContainerOffers}></FlameContainer>
        </div>
      )}

      {item.status === ItemStatus.Active && (
        <CircleButton onClick={callToActionOnClick.bind(this, item.id)}></CircleButton>
      )}

      {item.status === ItemStatus.Used && (
        <CheckButton>
          <CheckIcon></CheckIcon>
        </CheckButton>
      )}

    </RewardOfferItemContent>
  );
};


